import React from 'react'

const ArrowUpIcon: React.FC<{ dimension?: string }> = ({ dimension = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    className="feather feather-chevron-up"
    viewBox="0 0 24 24"
  >
    <path d="M18 15L12 9 6 15"></path>
  </svg>
)
export default ArrowUpIcon
